export default "__VITE_ASSET__B_c1HOIL__"